<template>
  <div class="row">
    <GenericProps
      :settings.sync="settings"
      :parameters="genericParameters"
      @update:settings="updateNodeParent"
    />

    <div
      class="cf-node-properties__field col-md-12 display-flex"
    >
      <label class="control-label">
        {{ goToNodeParameter.displayName }} <span v-if="!goToNodeParameter.isOptional">*</span>
        <i
          v-tooltip.top="goToNodeParameter.description"
          class="fa fa-question-circle m-l-5"
          aria-hidden="true"
        />
      </label>

      <div
        v-if="selectedNode"
        class="btn-group display-flex flex--grow"
      >
        <button
          class="btn btn-pre-value m-r-10 flex--grow"
          :title="$t('EDIT_SELECTED_NODE')"
          @click="viewGoToNode"
        >
          {{ selectedNode }}
          <i
            class="fa fa-reply m-l-5 p-0"
            aria-hidden="true"
          />
        </button>
        <button
          class="btn btn-primary"
          @click="onSelect"
        >
          <i
            class="fa fa-crosshairs p-0"
            aria-hidden="true"
          />
        </button>
      </div>
      <div
        v-else 
        class="btn-group"
      >
        <button
          class="btn btn-primary fill-width"
          @click="onSelect"
        >
          {{ $t('SELECT_NODE') }}
          <i
            class="fa fa-crosshairs m-l-10"
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import messages from '../../../../locales';
import {
  getFieldError,
  createSettingsHierarchy
} from '../../../../helpers/node';
import nodePropsMixin from '@/modules/ivrs/mixins/nodePropsMixin';
import { merge } from 'lodash';

export default {
  name: 'GoToNodeProps',

  mixins: [nodePropsMixin],

  props: {
    nodes: {
      type: Array,
      default: () => []
    },
    selectedNodeToRoute: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      goToNode: {},
    };
  },
  computed: {
    selectedNode() {
      return this.goToNode.stepName ? this.goToNode.stepName : this.goToNode.displayName;
    },

    genericParameters() {
      return this.node.parameters.filter(p => p.name !== 'goToNodeId');
    },

    goToNodeParameter() {
      return this.node.parameters.find(p => p.name === 'goToNodeId');
    }
  },
  watch: {
    selectedNodeToRoute() {
      if (this.selectedNodeToRoute) {
        this.goToNode = this.selectedNodeToRoute;
        this.settings.goToNodeId = this.selectedNodeToRoute.id;
        this.updateNodeParent();
      }
    }
  },
  created() {
    if (this.node && this.node.settings && this.node.settings.goToNodeId) {
      this.goToNode = this.nodes.find((node) => node.id == this.node.settings.goToNodeId) || {};
    }
    this.buildNodeSettings();
  },
  methods: {
    getFieldError,

    buildNodeSettings() {
      // Sets value of settings data
      this.settings = createSettingsHierarchy(this.node, undefined, undefined, this.node.settings);
      // Merges built settings hierarchy with current node settings
      this.settings = merge(this.settings.root, this.node.settings);

      this.updateNodeParent();
    },

    onSelect() {
      this.$emit('goToNodeSelectMode', true);
    },
    
    viewGoToNode() {
      this.$emit('selectNode', this.goToNode);
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>